var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconEyeArtwork = function SvgIconEyeArtwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    stroke: "#616879",
    d: "M11.5 13.832a3.832 3.832 0 0 1-3.83-3.83 3.832 3.832 0 0 1 3.83-3.83 3.832 3.832 0 0 1 3.83 3.83 3.832 3.832 0 0 1-3.83 3.83Zm0-7.16a3.334 3.334 0 0 0-3.33 3.33 3.334 3.334 0 0 0 3.33 3.33 3.334 3.334 0 0 0 3.33-3.33 3.334 3.334 0 0 0-3.33-3.33Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    stroke: "#616879",
    d: "M2.171 12.731c-.467-.728-.716-1.713-.716-2.727 0-1.013.249-2.001.716-2.734 2.381-3.712 5.788-5.79 9.33-5.79 3.54 0 6.947 2.078 9.318 5.79.468.728.716 1.713.716 2.727 0 1.013-.248 2.002-.716 2.734-2.371 3.712-5.778 5.79-9.319 5.79-3.551 0-6.958-2.078-9.329-5.79Zm9.33-10.75c-3.444 0-6.676 2.067-8.902 5.56-.44.687-.641 1.59-.641 2.46 0 .868.2 1.771.64 2.458 2.227 3.494 5.459 5.561 8.902 5.561 3.443 0 6.675-2.067 8.901-5.56.44-.687.642-1.59.642-2.46 0-.868-.201-1.772-.642-2.46-2.226-3.493-5.458-5.56-8.9-5.56Z"
  })));
};
export default SvgIconEyeArtwork;